var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","small":"","block":_vm.block},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("add")]),_c('span',[_vm._v("Add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }